import { render, staticRenderFns } from "./DashboardTodayAudits.vue?vue&type=template&id=2d13680c"
import script from "./DashboardTodayAudits.vue?vue&type=script&lang=ts"
export * from "./DashboardTodayAudits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports